import React from 'react';
import './index.css'
import DropdownMenu from '../common/DropdownMenu';
import { TicketFormModel } from '../../models/ticket.model';
import Autocomplete from '../common/Autocomplete';
import { itemSelection } from '../../models/itemSelection.model';

interface NotificationsProps {
  action?: string
  handleSelection?: any
  notificationProfilesList: itemSelection[]
  ticketForm: TicketFormModel
}

const Notifications: React.FC<NotificationsProps> = ({action, handleSelection, notificationProfilesList = [], ticketForm }) => {

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <DropdownMenu label='Notificaciones'>
              <div className='tkt-form-section-item'>
                <Autocomplete
                  label='Perfil'
                  placeholder='Perfil'
                  disabled={!(action === 'create')}
                  options={notificationProfilesList}
                  value={ticketForm.notification_profile}
                  name='notification_profile'
                  handleSelection={handleSelection}
                  required
                />
              </div>
        </DropdownMenu>
      </div>

    </React.Fragment>
  );
}

export default Notifications;
